import Divider from "components/ui/divider"
import Media from "components/ui/media"
import Shimmer from "components/ui/shimmer"

import { GridContainer } from "../products"
import Placeholder from "../products/placeholder"

import FilterAccordionLoading from "./filter-accordion-loading"

const Shimmers = () => (
  <div className="contained-wide">
    <div
      className="aspect-(--base-aspect-ratio) tablet:aspect-(--tablet-aspect-ratio)"
      style={{
        "--base-aspect-ratio": "750 / 708",
        "--tablet-aspect-ratio": "2560 / 376",
      }}
    >
      <Shimmer className="h-full w-full" />
    </div>
    <div className="px-16">
      <div className="my-16 py-16">
        <Shimmer className="mb-16" style={{ height: "17px", width: "150px" }} />
        <div className="flex justify-between">
          <div className="desktop:w-3/4">
            <Shimmer
              className="desktop:mb-8 desktop:w-(--desktop-width) w-(--base-width) mb-16"
              style={{
                "--base-width": "200px",
                "--desktop-width": "400px",
                height: "30px",
              }}
            />
            <Shimmer
              className="desktop:w-(--desktop-width) desktop:h-(--desktop-height) h-(--base-height) w-(--base-width)"
              style={{
                "--base-height": "12px",
                "--base-width": "300px",
                "--desktop-height": "20px",
                "--desktop-width": "600px",
              }}
            />

            <Media lessThan="desktop">
              <Shimmer
                className="mt-8"
                style={{ height: "12px", width: "300px" }}
              />
            </Media>
          </div>

          <Media greaterThanOrEqual="desktop">
            <Shimmer style={{ height: "20px", width: "130px" }} />
          </Media>
        </div>
      </div>
      <Divider className="bg-grey-10" />
      <Media className="flex justify-between p-8" lessThan="desktop">
        <Shimmer style={{ height: "20px", width: "70px" }} />
        <Shimmer style={{ height: "20px", width: "135px" }} />
      </Media>
      <div className="flex justify-center">
        <Media className="max-w-215 w-1/4" greaterThanOrEqual="desktop">
          <FilterAccordionLoading />
        </Media>
        <div className="flex-1">
          <GridContainer>
            {[...Array(12)].map((_, i) => (
              <Placeholder index={i} key={`placeholder-${i}`} />
            ))}
          </GridContainer>
        </div>
      </div>
    </div>
  </div>
)

export default Shimmers
